import { Button } from '@chakra-ui/button';
import { Flex, Heading } from '@chakra-ui/layout';
import React from 'react';
import Lottie from 'react-lottie';
import { Link } from 'react-router-dom';
import animationData from '../../../assets/animations/404.json';
import { PageContainer } from '../../../components/container/PageContainer';

interface NotFoundPageProps {}

export const NotFoundPage: React.FC<NotFoundPageProps> = () => (
  <PageContainer isHeader center>
    <Flex direction="column" align="center">
      <Lottie
        isClickToPauseDisabled={true}
        options={{
          loop: true,
          autoplay: true,
          animationData,
          rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
          },
        }}
        width="66%"
        height="200px"
      />
      <Heading mt={4} size="md">
        Seite wurde nicht gefunden
      </Heading>
      <Button mt={4} to="/" colorScheme="brand" as={Link}>
        Hier kommst du zur Startseite zurück
      </Button>
    </Flex>
  </PageContainer>
);
